import { useEffect, useState } from "react";
import { Check, Minus } from "lucide-react";
import { api, money } from "@/lib/api";

/** Side-by-side comparison of the subscription categories, shown before payment. */
export const PlanComparison = ({ currentPlan }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/plans").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <div className="border border-border bg-card" data-testid="plan-comparison">
      <div className="px-6 py-4 border-b border-border">
        <p className="label-caps">What each subscription includes</p>
        {data.split && (
          <p className="text-xs text-muted-foreground mt-2 max-w-3xl" data-testid="plan-split-note">{data.split}</p>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[620px]">
          <thead>
            <tr className="border-b border-border bg-muted/60">
              <th className="p-4 text-left label-caps font-normal">Facility</th>
              {data.plans.map((p) => (
                <th key={p.value} className="p-4 text-left" data-testid={`plan-col-${p.value}`}>
                  <p className="font-display text-lg">{p.name}</p>
                  <p className="font-mono text-xs text-muted-foreground mt-1">
                    {money(p.fee)} per case · {money(p.half)} per side
                  </p>
                  {currentPlan === p.value && (
                    <span className="mt-2 inline-block bg-blue-900 text-white text-[10px] uppercase tracking-wider px-2 py-0.5"
                      data-testid={`plan-current-${p.value}`}>
                      Your plan
                    </span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.plans[0].features.map((f, i) => (
              <tr key={f.label} className="border-b border-border last:border-0">
                <td className="p-4 text-muted-foreground">{f.label}</td>
                {data.plans.map((p) => (
                  <td key={p.value} className="p-4" data-testid={`plan-${p.value}-feature-${i}`}>
                    {p.features[i].included ? (
                      <Check className="h-4 w-4 text-green-700 dark:text-green-500" />
                    ) : (
                      <Minus className="h-4 w-4 text-muted-foreground/60" />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {currentPlan === "basic" && (
        <p className="px-6 py-4 border-t border-border text-xs text-muted-foreground" data-testid="plan-upgrade-hint">
          Moving to full access costs {money(data.upgrade_fee)} on this case, shared equally at
          {" "}{money(data.upgrade_fee / 2)} per side — use "Upgrade to full access" on the case file.
        </p>
      )}
    </div>
  );
};

export default PlanComparison;
